import { baseUrl } from './urls'

export const METADATA_SECONDARY_TITLE = 'Derive Options Exchange for Cryptocurrency Onchain'
export const METADATA_TITLE = 'Derive - Options Exchange for Cryptocurrency Onchain'
export const METADATA_DESCRIPTION =
  'Derive is a decentralized protocol that creates unique and programmable onchain options, perpetuals, and structured products.'
export const METADATA_IMAGE = `${baseUrl}/images/preview.png`
